import notifications from "./notifications"


export default {
	modules: {
		notifications
	},
	strict: true,
	namespaced: true,
}